<div class="card">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4>{{ "MENU.MY_DOCUMENTS" | translate }}</h4>
    <a *ngIf="documents.length > 0" routerLink="/dashboard/my-documents">{{ "VIEW_ALL" | translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="documents.length < 1">{{ "NO_DOCUMENTS_TO_PROCESS" | translate }}</div>
    <div *ngFor="let document of documents" class="row mb-1">
      <div class="col-12">
        <div class="d-flex justify-content-between">
          <a [routerLink]="'/dashboard/user-document-view/' + document.document_id" class="text-break-line-1" [ngbTooltip]="document.document_data.title.length > 15 ? document.document_data.title : null">{{
            document.document_data.title
          }}</a>
          <!--REQUIRE ACCEPTION OR SIGNATURE-->
          <span class="badge badge-light-danger ml-05" *ngIf="document.document_data.require_acception && !document.document_data.require_signature && document.document_user_data.having_read == 0">
            {{ "REQUIRED_ACCEPTION" | translate }}
          </span>
          <span class="badge badge-light-danger ml-05" *ngIf="document.document_data.require_signature && document.document_user_data.signed == 0">
            {{ "REQUIRED_SIGNATURE" | translate }}
          </span>
          <span class="badge badge-pill badge-light-success" *ngIf="document.document_user_data.having_read == 1 && document.document_data.require_acception && !document.document_data.require_signature"
            >{{ "VIEWED" | translate }}
          </span>
          <span class="badge badge-pill badge-light-success" *ngIf="document.document_user_data.signed == 1 && document.document_data.require_signature">{{ "SIGNED" | translate }} </span>
        </div>

        <!--CATEGORY / DATE-->
        <div class="d-flex justify-content-between font-small-2 mt-025">
          <span class="font-weight-medium mb-0">
            {{ document.document_data.category }}
          </span>
          <span>
            {{ _utilsService.formatDate(document.document_data.send_date) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
